import * as React from 'react';
import styles from '../../styles/image.module.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const MIME_DICT = new Map([['apng', 'image/apng'], ['bmp', 'image/bmp'], ['gif', 'image/gif'], ['ico', 'image/ico'], ['cur', 'image/ico'], ['jpeg', 'image/jpeg'], ['jpg', 'image/jpeg'], ['png', 'image/png'], ['svg', 'image/svg'], ['webp', 'image/webp']]);
const getFileExt = src => {
  const pathname = src.split(/[?#]/)[0];
  const resultArray = pathname.split(/\./);
  return resultArray[resultArray.length - 1];
};
const getMimeType = src => {
  return MIME_DICT.get(getFileExt(src));
};
export const Component = function (_ref, ref) {
  let {
    onLoad,
    onError,
    src,
    sources,
    className,
    alt,
    title,
    objectFit,
    loading
  } = _ref;
  return /*#__PURE__*/_jsxs("picture", {
    className: className,
    children: [sources.map(_ref2 => {
      let {
        srcset,
        media,
        sizes
      } = _ref2;
      return /*#__PURE__*/_jsx("source", {
        srcSet: srcset,
        media: media,
        sizes: sizes,
        type: getMimeType(srcset)
      }, srcset + (media || '') + (sizes || ''));
    }), /*#__PURE__*/_jsx("img", {
      className: styles['image'],
      alt: alt,
      title: title,
      decoding: 'async',
      style: {
        objectFit
      },
      onLoad: onLoad,
      onError: onError,
      src: src,
      ref: ref,
      loading: loading
    })]
  });
};
Component.displayName = 'Picture';
export const Picture = /*#__PURE__*/React.forwardRef(Component);